window.onload = () => {
  const elements = document.querySelectorAll('[data-animation]')

  // Polyfill
  if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach
  }

  elements.forEach((element) => {
    element.setAttribute('data-animation-fired', 'true')
  })
}
